<template>
  <div class="work-order-container">
    <div class="work-order-container-top"></div>
    <div class="work-order-container-center">
      <div class="work-order-content">
        <div class="work-order-title" v-html="content.title"></div>
        <template v-for="(item, index) in content.content">
          <titleIndex :key="index" v-if="item.type === 'title'" :content="item"></titleIndex>
          <textIndex :key="index" v-if="item.type === 'text'" :content="item"></textIndex>
          <mediaIndex :key="index" v-if="mediaTypeArr.includes(item.type)" :content="item"></mediaIndex>
          <table1 :ref="`table1${item.key}`" :key="index" v-if="item.type === 'workOrderTable1'" :content="item"></table1>
          <table2 :ref="`table2${item.key}`" :key="index" v-if="item.type === 'workOrderTable2'" :content="item"></table2>
          <question :ref="`question${item.key}`" :key="index" v-if="item.type === 'workOrderQuestion'" :content="item"></question>
          <div class="textarea-box" :key="index" v-if="item.type === 'formTextarea'">
            <el-input v-model="item.text" type="textarea" placeholder="请输入您的总结"></el-input>
          </div>
        </template>
        <div class="submit-btn" :class="isSubmit ? 'submit-btn-disabled' : ''" @click.stop="submitHandle">提交</div>
        <div class="clear-both"></div>
      </div>
    </div>
    <div class="work-order-container-bottom"></div>
  </div>
</template>

<script>
import titleIndex from "../title/index.vue";
import textIndex from "../text/index.vue";
import mediaIndex from "../media/index.vue";
import table1 from "./table1.vue";
import table2 from "./table2.vue";
import question from "./question.vue";

export default {
  name: "workOrderIndex",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  components: {
    titleIndex,
    textIndex,
    mediaIndex,
    table1,
    table2,
    question,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      isSubmit: false,
      mediaTypeArr: ['image', 'video', 'audio', '3DModel'],
    }
  },
  methods: {
    submitHandle(e) {
      let funList = [];
      let refsList = this.$refs || {};
      Object.keys(refsList).forEach(key => {
        if(key.indexOf('table1') || key.indexOf('table2') || key.indexOf('question')) {
          funList.push(refsList[key][0].submitHandle())
        }
      });
      
      Promise.all(funList).then((resList) => {
        console.log(resList)
      })
      this.$message.success('提交成功！')
      this.findChapterFrom(e)
      // this.isSubmit = true
    }
  }
}
</script>

<style lang="scss" scoped>
.work-order-container{
  width: 712rem;
  margin-left: 22rem;
  padding-right: 8rem;
  padding-left: 2rem;
  position: relative;
  padding-bottom: 220rem;
  box-sizing: border-box;
  margin-top: 20rem;

  .work-order-container-top{
    width: 712rem;
    height: 150rem;
    background: url(~@/assets/images/books/book1/workOrder/back-top.png) center center no-repeat;
    background-size: 712rem 150rem;
  }
  .work-order-container-center{
    width: 712rem;
    // height: 150rem;
    background: url(~@/assets/images/books/book1/workOrder/back.png) center center repeat;
    background-size: 712rem 100%;
    position: relative;
    margin-bottom: -2rem;
    margin-top: -1rem;
    z-index: 3;

    .work-order-content{
      width: 702rem;

      .work-order-title{
        width: 612rem;
        font-size: 32rem;
        color: #fff;
        font-weight: bold;
        line-height: 74rem;
        text-align: center;
        background: #3F83E4;
        border-radius: 6rem;
        margin: 0 auto;
        margin-left: 40rem;
      }

      .textarea-box{
        width: 660rem;
        margin-left: 16rem;
        margin-top: 18rem;
        /deep/.el-textarea{
          .el-textarea__inner{
            height: 360rem;
            &:focus {
              border: 1px solid #0FC29A;
            }
          }
        }
      }

      .submit-btn{
        width: 180rem;
        height: 52rem;
        line-height: 52rem;
        text-align: center;
        color: #fff;
        font-size: 26rem;
        background: #3F83E4;
        border-radius: 6rem;
        margin: 30rem auto 0;
        margin-bottom: -124rem;
        cursor: pointer;
      }

      .submit-btn-disabled{
        background: #BFBFBF;
        cursor: not-allowed;
      }

      .clear-both{
        width: 100%;
        height: 1rem;
        clear: both;
      }
    }
  }
  .work-order-container-bottom{
    position: absolute;
    width: 712rem;
    height: 200rem;
    background: url(~@/assets/images/books/book1/workOrder/back-bottom.png) center center no-repeat;
    background-size: 712rem 200rem;
  }
}
</style>